import { AvailableOperationTypes } from "../models/operations/available-operation-types";

export const nextOperationLoaderConfig = {
    [AvailableOperationTypes.ACEP]: {
      text: 'signaturit_pro.loading.finish_simple_signature_message',
      icon: 'assets/images/simple--signature.png'
    },
    [AvailableOperationTypes.SIGBIO]: {
      text: 'signaturit_pro.loading.finish_bio_signature_message',
      icon: 'assets/images/advanced--signature.png'
    },
    [AvailableOperationTypes.SIG]: {
      text: 'signaturit_pro.loading.finish_digital_cert_signature_message',
      icon: 'assets/images/certified--mail.png'
    },
    [AvailableOperationTypes.RVDOTP]: {
      text: 'signaturit_pro.loading.finish_digital_sms_signature_message',
      icon: 'assets/images/certified--sms.png'
    },
    [AvailableOperationTypes.DWN]: {
      text: 'signaturit_pro.loading.finish_certificate_dwn_automaticDownload',
      icon: 'assets/images/certified--mail.png'
    },
  }
